import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const generateQuoteDocumentSelector = selector({
    key: 'generateQuoteDocumentSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const document = await OnlineSales.generateQuoteDocument(jobNumber, sessionId);
        if (!document?.base64PDF) {
            throw Error('Kunne ikke generere og hente Tilbud');
        }
        return document;
    }
});
